/* ============================================================
   Cuộn lên đầu khi đổi trang.

   React Router không tự làm việc này: đổi route chỉ là thay component, vị trí
   cuộn của trang cũ được giữ nguyên. Khách đang ở giữa lưới acc trang chủ bấm
   "Xem chi tiết" thì trang acc mở ra ở đúng độ cao đó — nhìn như trang bị vỡ
   hoặc thiếu nội dung.

   Ba trường hợp CỐ Ý không cuộn (nếu bỏ, ba luồng dưới đây gãy):

     1. Back/Forward (history.action === "POP") — trình duyệt trả người dùng
        về đúng chỗ họ đang đọc; cuộn lên đầu là xoá mất vị trí đó.
     2. Link có neo (#phan-nao) — điểm đến do chính neo quyết định.
     3. /?game=cf — Homepage.jsx tự cuộn tới thanh chọn game rồi mới dừng
        (xem scrollToElement ở đó). Cuộn thêm ở đây là hai bên giành nhau.
   ============================================================ */

import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, search, hash } = useLocation();
  const history = useHistory();

  useEffect(() => {
    if (history.action === "POP") return;
    if (hash) return;
    if (pathname === "/" && /[?&]game=/.test(search)) return;

    /* Nhảy thẳng, không "smooth": cuộn mượt qua vài nghìn pixel vừa chậm vừa
       làm người xem tưởng trang đang tự chạy. */
    window.scrollTo(0, 0);
  }, [pathname, search, hash, history.action]);

  return null;
}
